import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 * Clean circular loader with a softly pulsing dot in the center.
 * Replaces the older bouncing-bars treatment everywhere it was used.
 *
 *   <Loader />               // 32px
 *   <Loader size="large" />  // 44px
 *   <Loader size="xl" />     // 56px
 */
const Loader = ({ size = 'medium' }) => {
  const dimension = size === 'xl' ? 56 : size === 'large' ? 44 : 32;
  const thickness = size === 'xl' ? 3 : 3.2;
  return (
    <Box
      sx={{
        position: 'relative',
        width: dimension,
        height: dimension,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress
        size={dimension}
        thickness={thickness}
        sx={{
          color: 'primary.main',
          opacity: 0.85,
          '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round',
          },
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          width: 6,
          height: 6,
          borderRadius: '50%',
          backgroundColor: 'primary.main',
          opacity: 0.5,
          animation: 'loaderPulse 1.4s ease-in-out infinite',
          '@keyframes loaderPulse': {
            '0%, 100%': { opacity: 0.3, transform: 'scale(0.85)' },
            '50%': { opacity: 0.9, transform: 'scale(1.15)' },
          },
        }}
      />
    </Box>
  );
};

// Backward-compat alias — the rest of the app currently calls it `WaveLoading`.
export const WaveLoading = Loader;
export default Loader;
